import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

export const getVendorCategoriesReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_CATEGORIES_API
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorCategoryReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_CATEGORY_API

    const payload = {
        name: action.data.name,
        description: action.data.description || null,
        userId: action.data.userId,
        society_id: action.data.societyId,
    };

    return axiosInstance.post(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Category created successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const updateVendorCategoryReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_CATEGORY_API.replace(':id', action.data.categoryId)

    const payload = {
        category_id: action.data.categoryId,
        name: action.data.name,
        description: action.data.description || null,
        society_id: action.data.societyId,
    };

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Category updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorCategoryReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_CATEGORY_API.replace(':id', action.data.categoryId)

    return axiosInstance.delete(url, { data: { category_id: action.data.categoryId, society_id: action.data.societyId } })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Category deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_API

    const formData = new FormData();

    formData.append('companyName', action.data.companyName);
    formData.append('contactPerson', action.data.contactPerson);
    formData.append('category', action.data.category);
    formData.append('phone', action.data.phone);
    formData.append('userId', action.data.userId);
    if (action.data.societyId) formData.append('societyId', action.data.societyId);

    if (action.data.alternatePhone) formData.append('alternatePhone', action.data.alternatePhone);
    if (action.data.email) formData.append('email', action.data.email);
    if (action.data.website) formData.append('website', action.data.website);
    if (action.data.amount) formData.append('amount', action.data.amount);
    if (action.data.gstNumber) formData.append('gstNumber', action.data.gstNumber);
    if (action.data.panNumber) formData.append('panNumber', action.data.panNumber);
    if (action.data.tanNumber) formData.append('tanNumber', action.data.tanNumber);
    if (action.data.address) formData.append('address', action.data.address);
    if (action.data.countryId) formData.append('countryId', action.data.countryId);
    if (action.data.stateId) formData.append('stateId', action.data.stateId);
    if (action.data.cityId) formData.append('cityId', action.data.cityId);
    if (action.data.pincode) formData.append('pincode', action.data.pincode);
    if (action.data.bankName) formData.append('bankName', action.data.bankName);
    if (action.data.accountNumber) formData.append('accountNumber', action.data.accountNumber);
    if (action.data.ifscCode) formData.append('ifscCode', action.data.ifscCode);
    if (action.data.accountHolderName) formData.append('accountHolderName', action.data.accountHolderName);
    if (action.data.contractStartDate) formData.append('contractStartDate', action.data.contractStartDate);
    if (action.data.contractEndDate) formData.append('contractEndDate', action.data.contractEndDate);
    if (action.data.contractAmount) formData.append('contractAmount', action.data.contractAmount);
    if (action.data.paymentTerms) formData.append('paymentTerms', action.data.paymentTerms);
    if (action.data.contractStatus) formData.append('contractStatus', action.data.contractStatus);
    if (action.data.status) formData.append('status', action.data.status);
    if (action.data.notes) formData.append('notes', action.data.notes);

    if (action.data.msmeStatus) formData.append('msmeStatus', action.data.msmeStatus);
    if (action.data.rcmApplicable) formData.append('rcmApplicable', action.data.rcmApplicable);
    if (action.data.tdsApplicable) formData.append('tdsApplicable', action.data.tdsApplicable);
    if (action.data.role_id) formData.append('role_id', action.data.role_id);

    // File uploads
    if (action.data.documents?.panCard) formData.append('panCardUpload', action.data.documents.panCard);
    if (action.data.documents?.gstCertificate) formData.append('gstCertUpload', action.data.documents.gstCertificate);
    if (action.data.documents?.tanCertificate) formData.append('tanCertUpload', action.data.documents.tanCertificate);
    if (action.data.documents?.msmeCertificate) formData.append('msmeCertUpload', action.data.documents.msmeCertificate);

    return axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor created successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorDetailsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_DETAILS_API.replace(':id', action.data.vendorId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorsListReq = (action) => {
    const { page = 1, limit = 10, search = '', category_id = '' } = action.data || {};
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (search) params.append('search', search);
    if (category_id) params.append('category_id', category_id);

    const url = `${apiEndpoints.SOCIETY_GET_VENDORS_LIST_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const updateVendorReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_API.replace(':id', action.data.vendorId)

    // Map form fields to API fields (camelCase to snake_case)
    const payload = {
        business_name: action.data.companyName,
        contact_person: action.data.contactPerson,
        category_id: action.data.category,
        phone: action.data.phone,
        alternate_phone: action.data.alternatePhone || null,
        email: action.data.email || null,
        website: action.data.website || null,
        amount: action.data.amount || null,
        gst_number: action.data.gstNumber || null,
        pan_number: action.data.panNumber || null,
        tan_number: action.data.tanNumber || null,
        address: action.data.address || null,
        country_id: action.data.countryId || null,
        state_id: action.data.stateId || null,
        city_id: action.data.cityId || null,
        pincode: action.data.pincode || null,
        bank_name: action.data.bankName || null,
        account_number: action.data.accountNumber || null,
        ifsc_code: action.data.ifscCode || null,
        account_holder_name: action.data.accountHolderName || null,
        contract_start_date: action.data.contractStartDate || null,
        contract_end_date: action.data.contractEndDate || null,
        contract_amount: action.data.contractAmount || null,
        payment_terms: action.data.paymentTerms || null,
        status: action.data.status || 'Active',
        contract_status: action.data.contractStatus || null,
        notes: action.data.notes || null,
        msme_status: action.data.msmeStatus || null,
        rcm_applicable: action.data.rcmApplicable || 'N',
        tds_applicable: action.data.tdsApplicable || 'N',
        user_id: action.data.userId,
        society_id: action.data.societyId,
    };
    if (action.data.role_id) payload.role_id = Number(action.data.role_id);

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_API.replace(':id', action.data.vendorId)
    return axiosInstance.delete(url)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getAllVendorsReq = (action) => {
    const { category_id, society_id } = action.data || {};
    const params = new URLSearchParams();
    if (society_id) params.append('society_id', society_id);
    if (category_id) params.append('category_id', category_id);
    const url = `${apiEndpoints.SOCIETY_GET_ALL_VENDORS_API}?${params.toString()}`;
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR SETTING ============

export const getVendorSettingReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_SETTING_API.replace(':vendorId', action.data.vendorId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR TARIFFS ============

export const getVendorTariffsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_TARIFFS_API.replace(':vendorId', action.data.vendorId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorTariffReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_TARIFF_API.replace(':vendorId', action.data.vendorId)

    const payload = {
        item_name: action.data.itemName,
        item_type: action.data.itemType,
        gl_name: action.data.glName,
        unit_rate: action.data.unitRate,
        cgst_rate: action.data.cgstRate,
        sgst_rate: action.data.sgstRate,
        igst_rate: action.data.igstRate,
        tds_rate: action.data.tdsRate,
        tds_section: action.data.tdsSection,
        society_id: action.data.societyId,
    };

    return axiosInstance.post(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor tariff added successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorTariffReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_TARIFF_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.tariffId)
    return axiosInstance.delete(url)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor tariff deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getAllVendorTariffsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_ALL_VENDOR_TARIFFS_API.replace(':vendorId', action.data.vendorId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR BILLS ============

export const getVendorBillsListReq = (action) => {
    const { page = 1, limit = 10, search = '', vendor_id = '', status = '', societyId } = action.data || {};
    const params = new URLSearchParams();
    params.append('society_id', societyId);
    params.append('page', page);
    params.append('limit', limit);
    if (search) params.append('search', search);
    if (vendor_id) params.append('vendor_id', vendor_id);
    if (status) params.append('status', status);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_BILLS_LIST_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorBillDetailsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_BILL_DETAILS_API.replace(':id', action.data.billId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorBillReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_BILL_API

    const payload = {
        is_draft: action.data.is_draft ?? 0,
        society_id: action.data.societyId,
        vendor_id: action.data.vendorId,
        bill_type: action.data.billType || null,
        bill_number: action.data.billNumber,
        bill_date: action.data.billDate,
        due_date: action.data.dueDate,
        description: action.data.description,
        tariff_details: action.data.tariffDetails || [],
        subtotal: action.data.subtotal || 0,
        total_cgst: action.data.totalCgst || 0,
        total_sgst: action.data.totalSgst || 0,
        total_igst: action.data.totalIgst || 0,
        total_tds: action.data.totalTds || 0,
        round_off: action.data.roundOff || 0,
        sub_total: action.data.subTotal || 0,
        net_total: action.data.netTotal || 0,
        field_posting_date: action.data.fieldPostingDate || 'bill_date',
        rcm_applicable: action.data.rcmApplicable || 'N',
        tds_applicable: action.data.tdsApplicable || 'N',
        pan_number: action.data.panNumber || null,
        // GL codes
        sgst_gl_code: action.data.sgstGlCode || null,
        cgst_gl_code: action.data.cgstGlCode || null,
        igst_gl_code: action.data.igstGlCode || null,
        tds_gl_code: action.data.tdsGlCode || null,
        round_off_gl_code: action.data.roundOffGlCode || null,
        rcm_sgst_code: action.data.rcmSgstCode || null,
        rcm_cgst_code: action.data.rcmCgstCode || null,
        rcm_igst_code: action.data.rcmIgstCode || null,
        rcm_cgst_receivable_code: action.data.rcmCgstReceivableCode || null,
        rcm_sgst_receivable_code: action.data.rcmSgstReceivableCode || null,
        rcm_igst_receivable_code: action.data.rcmIgstReceivableCode || null,
        status: action.data.status || 'Pending',
        notes: action.data.notes || null,
    };

    return axiosInstance.post(url, payload)
        .then(response => {
            if (response.success && !action.data.silent) {
                notify('success', response.message || 'Vendor bill created successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (!action.data.silent) {
                notify('error', errors.response?.data?.message || "Something went wrong");
            }
            return errors
        })
}

export const updateVendorBillReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_BILL_API.replace(':id', action.data.billId)

    const payload = {
        is_draft: action.data.is_draft ?? 0,
        society_id: action.data.societyId,
        vendor_id: action.data.vendorId,
        bill_type: action.data.billType || null,
        bill_number: action.data.billNumber,
        bill_date: action.data.billDate,
        due_date: action.data.dueDate,
        description: action.data.description,
        tariff_details: action.data.tariffDetails || [],
        subtotal: action.data.subtotal || 0,
        total_cgst: action.data.totalCgst || 0,
        total_sgst: action.data.totalSgst || 0,
        total_igst: action.data.totalIgst || 0,
        total_tds: action.data.totalTds || 0,
        round_off: action.data.roundOff || 0,
        sub_total: action.data.subTotal || 0,
        net_total: action.data.netTotal || 0,
        field_posting_date: action.data.fieldPostingDate || 'bill_date',
        rcm_applicable: action.data.rcmApplicable || 'N',
        tds_applicable: action.data.tdsApplicable || 'N',
        pan_number: action.data.panNumber || null,
        sgst_gl_code: action.data.sgstGlCode || null,
        cgst_gl_code: action.data.cgstGlCode || null,
        igst_gl_code: action.data.igstGlCode || null,
        tds_gl_code: action.data.tdsGlCode || null,
        round_off_gl_code: action.data.roundOffGlCode || null,
        rcm_sgst_code: action.data.rcmSgstCode || null,
        rcm_cgst_code: action.data.rcmCgstCode || null,
        rcm_igst_code: action.data.rcmIgstCode || null,
        rcm_cgst_receivable_code: action.data.rcmCgstReceivableCode || null,
        rcm_sgst_receivable_code: action.data.rcmSgstReceivableCode || null,
        rcm_igst_receivable_code: action.data.rcmIgstReceivableCode || null,
        notes: action.data.notes || null,
    };

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor bill updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorBillReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_BILL_API.replace(':id', action.data.billId)
    return axiosInstance.delete(url)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor bill deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const approveVendorBillReq = (action) => {
    const url = apiEndpoints.SOCIETY_APPROVE_VENDOR_BILL_API.replace(':id', action.data.billId)
    return axiosInstance.put(url)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Vendor bill approved successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR BANK ACCOUNTS ============

export const getVendorBankAccountsReq = (action) => {
    const { vendorId, societyId } = action.data;
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);
    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_BANK_ACCOUNTS_API.replace(':vendorId', vendorId)}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorBankAccountReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_API.replace(':vendorId', action.data.vendorId)

    const payload = {
        bank_name: action.data.bankName,
        account_number: action.data.accountNumber,
        ifsc_code: action.data.ifscCode,
        account_holder_name: action.data.accountHolderName,
        bank_type: action.data.bankType || 'Saving',
        is_primary: action.data.isPrimary || false,
        society_id: action.data.societyId,
    };

    return axiosInstance.post(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Bank account added successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const updateVendorBankAccountReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.bankAccountId)

    const payload = {
        bank_name: action.data.bankName,
        account_number: action.data.accountNumber,
        ifsc_code: action.data.ifscCode,
        account_holder_name: action.data.accountHolderName,
        bank_type: action.data.bankType || 'Saving',
        is_primary: action.data.isPrimary || false,
        society_id: action.data.societyId,
    };

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Bank account updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorBankAccountReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.bankAccountId)

    return axiosInstance.delete(url, { data: { society_id: action.data.societyId } })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Bank account deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const payVendorBillReq = (action) => {
    const url = apiEndpoints.SOCIETY_PAY_VENDOR_BILL_API.replace(':id', action.data.billId)

    const payload = {
        paid_date: action.data.paidDate,
        payment_method: action.data.paymentMethod || null,
        transaction_id: action.data.transactionId || null,
    };

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Payment recorded successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR AMC TRACKER ============

export const getVendorAmcListReq = (action) => {
    const { vendorId, societyId } = action.data;
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);
    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_AMC_LIST_API.replace(':vendorId', vendorId)}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorAmcDetailsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_AMC_DETAILS_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.amcId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorAmcReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_AMC_API.replace(':vendorId', action.data.vendorId)

    const payload = {
        amc_type: action.data.amcType,
        amc_starts: action.data.amcStartDate,
        amc_ends: action.data.amcEndDate,
        service_schedule: action.data.serviceSchedule || null,
        expiry_reminder: action.data.expiryReminderDays || null,
        service_reminder: action.data.serviceReminderDays || null,
        rcm_applicable: action.data.rcmApplicable || 'N',
        employee_type: action.data.employeeType || null,
        employees: action.data.employees || null,
        managing_committees: action.data.managingCommittees || null,
        mc_member: action.data.mcMember || null,
        description: action.data.description || null,
        society_id: action.data.societyId,
    };

    return axiosInstance.post(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'AMC tracker added successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const updateVendorAmcReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_AMC_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.amcId)

    const payload = {
        amc_type: action.data.amcType,
        amc_starts: action.data.amcStartDate,
        amc_ends: action.data.amcEndDate,
        service_schedule: action.data.serviceSchedule || null,
        expiry_reminder: action.data.expiryReminderDays || null,
        service_reminder: action.data.serviceReminderDays || null,
        rcm_applicable: action.data.rcmApplicable || 'N',
        employee_type: action.data.employeeType || null,
        employees: action.data.employees || null,
        managing_committees: action.data.managingCommittees || null,
        mc_member: action.data.mcMember || null,
        description: action.data.description || null,
        society_id: action.data.societyId,
    };

    return axiosInstance.put(url, payload)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'AMC tracker updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorAmcReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_AMC_API
        .replace(':vendorId', action.data.vendorId)
        .replace(':id', action.data.amcId)
    return axiosInstance.delete(url, { data: { society_id: action.data.societyId } })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'AMC tracker deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR GL CODES ============

export const getVendorGlCodesReq = (action) => {
    const { societyId } = action.data || {};
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_GL_CODES_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR GL CODE DROPDOWN ============

export const getVendorGlCodeDropdownReq = (action) => {
    const { societyId, type = 'account', groupGlCode = '04' } = action.data || {};
    const params = new URLSearchParams();
    if (societyId) params.append('societyId', societyId);
    if (type) params.append('type', type);
    if (groupGlCode) params.append('groupGlCode', groupGlCode);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR ROUND OFF GL CODE ============

export const getVendorRoundOffGlReq = (action) => {
    const { societyId } = action.data || {};
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_ROUND_OFF_GL_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR BILLING SETTINGS ============

export const getVendorBillingSettingsReq = (action) => {
    const { societyId } = action.data || {};
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_BILLING_SETTINGS_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

// ============ VENDOR PAYMENTS ============

export const getVendorPaymentsListReq = (action) => {
    const { page = 1, limit = 10, search = '', vendor_id = '', payment_mode = '', societyId } = action.data || {};
    const params = new URLSearchParams();
    params.append('society_id', societyId);
    params.append('page', page);
    params.append('limit', limit);
    if (search) params.append('search', search);
    if (vendor_id) params.append('vendor_id', vendor_id);
    if (payment_mode) params.append('payment_mode', payment_mode);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_PAYMENTS_LIST_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorPaymentDetailsReq = (action) => {
    const url = apiEndpoints.SOCIETY_GET_VENDOR_PAYMENT_DETAILS_API.replace(':id', action.data.paymentId)
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const createVendorPaymentReq = (action) => {
    const url = apiEndpoints.SOCIETY_CREATE_VENDOR_PAYMENT_API

    const formData = new FormData();
    formData.append('societyId', action.data.societyId);
    formData.append('vendorId', action.data.vendorId);
    formData.append('vendorName', action.data.vendorName || '');
    formData.append('vendorGlCode', action.data.vendorGlCode || '');
    formData.append('paymentType', action.data.paymentType);
    formData.append('paymentDate', action.data.paymentDate);
    formData.append('paymentMade', action.data.paymentMade);
    formData.append('paymentMode', action.data.paymentMode);
    // The account the money leaves — the debit side of the journal entry.
    formData.append('paidThrough', action.data.paidThrough || '');
    formData.append('utrNo', action.data.utrNo || '');
    formData.append('notes', action.data.notes || '');
    formData.append('amountUsedForPayments', action.data.amountUsedForPayments || 0);
    formData.append('dueAmount', action.data.dueAmount || 0);
    formData.append('tdsApplicable', action.data.tdsApplicable || 'N');
    formData.append('tdsRate', action.data.tdsRate || 0);
    formData.append('tdsSection', action.data.tdsSection || '');
    formData.append('tdsAmount', action.data.tdsAmount || 0);
    formData.append('amountAfterTds', action.data.amountAfterTds || 0);
    // Draft keeps the payment out of the ledger; Post writes the journal entry.
    formData.append('generateStatus', action.data.generateStatus === 'Post' ? 'Post' : 'Draft');
    if (action.data.paymentDoc) formData.append('paymentDoc', action.data.paymentDoc);

    // Append bills array as bills[0][id], bills[0][date], etc.
    const bills = action.data.bills || [];
    bills.forEach((bill, index) => {
        formData.append(`bills[${index}][id]`, bill.id);
        formData.append(`bills[${index}][date]`, bill.date || '');
        formData.append(`bills[${index}][dueDate]`, bill.dueDate || '');
        formData.append(`bills[${index}][billNo]`, bill.billNo || '');
        formData.append(`bills[${index}][billAmount]`, bill.billAmount || 0);
        formData.append(`bills[${index}][amountDue]`, bill.amountDue || 0);
        formData.append(`bills[${index}][payment]`, bill.payment || 0);
    });

    return axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Payment recorded successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const updateVendorPaymentReq = (action) => {
    const url = apiEndpoints.SOCIETY_UPDATE_VENDOR_PAYMENT_API.replace(':id', action.data.paymentId)

    const formData = new FormData();
    formData.append('societyId', action.data.societyId);
    formData.append('vendorId', action.data.vendorId);
    formData.append('vendorName', action.data.vendorName || '');
    formData.append('vendorGlCode', action.data.vendorGlCode || '');
    formData.append('paymentType', action.data.paymentType);
    formData.append('paymentDate', action.data.paymentDate);
    formData.append('paymentMade', action.data.paymentMade);
    formData.append('paymentMode', action.data.paymentMode);
    formData.append('utrNo', action.data.utrNo || '');
    formData.append('notes', action.data.notes || '');
    formData.append('amountUsedForPayments', action.data.amountUsedForPayments || 0);
    formData.append('dueAmount', action.data.dueAmount || 0);
    formData.append('tdsApplicable', action.data.tdsApplicable || 'N');
    formData.append('tdsRate', action.data.tdsRate || 0);
    formData.append('tdsSection', action.data.tdsSection || '');
    formData.append('tdsAmount', action.data.tdsAmount || 0);
    formData.append('amountAfterTds', action.data.amountAfterTds || 0);
    if (action.data.paymentDoc) formData.append('paymentDoc', action.data.paymentDoc);

    const bills = action.data.bills || [];
    bills.forEach((bill, index) => {
        formData.append(`bills[${index}][id]`, bill.id);
        formData.append(`bills[${index}][date]`, bill.date || '');
        formData.append(`bills[${index}][dueDate]`, bill.dueDate || '');
        formData.append(`bills[${index}][billNo]`, bill.billNo || '');
        formData.append(`bills[${index}][billAmount]`, bill.billAmount || 0);
        formData.append(`bills[${index}][amountDue]`, bill.amountDue || 0);
        formData.append(`bills[${index}][payment]`, bill.payment || 0);
    });

    return axiosInstance.put(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Payment updated successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const deleteVendorPaymentReq = (action) => {
    const url = apiEndpoints.SOCIETY_DELETE_VENDOR_PAYMENT_API.replace(':id', action.data.paymentId)
    return axiosInstance.delete(url)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Payment deleted successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorUnpaidBillsReq = (action) => {
    const { vendor_id, societyId } = action.data || {};
    const params = new URLSearchParams();
    if (societyId) params.append('society_id', societyId);
    if (vendor_id) params.append('vendor_id', vendor_id);

    const url = `${apiEndpoints.SOCIETY_GET_VENDOR_UNPAID_BILLS_API}?${params.toString()}`
    return axiosInstance.get(url)
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const saveVendorBillingSettingsReq = (action) => {
    const url = apiEndpoints.SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_API

    // const payload = {
    //     gst_applicable: action.data.gstApplicable || false,
    //     default_gst_rate: action.data.defaultGstRate || 18,
    //     igst_applicable: action.data.igstApplicable || false,
    //     default_igst_rate: action.data.defaultIgstRate || 18,
    //     tds_applicable: action.data.tdsApplicable || false,
    //     default_tds_rate: action.data.defaultTdsRate || 10,
    //     tds_section: action.data.tdsSection || null,
    //     sgst_gl: action.data.sgstGl || null,
    //     cgst_gl: action.data.cgstGl || null,
    //     igst_gl: action.data.igstGl || null,
    //     rcm_sgst_payable: action.data.rcmSgstPayable || null,
    //     rcm_cgst_payable: action.data.rcmCgstPayable || null,
    //     rcm_igst_payable: action.data.rcmIgstPayable || null,
    //     rcm_sgst_receivable: action.data.rcmSgstReceivable || null,
    //     rcm_cgst_receivable: action.data.rcmCgstReceivable || null,
    //     rcm_igst_receivable: action.data.rcmIgstReceivable || null,
    //     round_off: action.data.roundOff || null,
    //     tds_gl: action.data.tdsGl || null,
    //     item_type: action.data.itemType || 'amount',
    //     field_posting_date: action.data.fieldPostingDate || 'bill_date',
    //     society_id: action.data.societyId,
    // };

    return axiosInstance.post(url, action.data)
        .then(response => {
            if (response.success) {
                notify('success', response.message || 'Billing settings saved successfully');
            }
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            notify('error', errors.response?.data?.message || "Something went wrong");
            return errors
        })
}

export const getVendorsDropdownReq = (action) => {
    const params = {};
    if (action?.data?.societyId) params.society_id = action.data.societyId;
    return axiosInstance.get(apiEndpoints.SOCIETY_GET_VENDORS_DROPDOWN_API, { params })
        .then(response => response)
        .catch((errors) => {
            console.log("errors", errors);
            return errors
        })
}

// Excel bulk upload. Ships multipart/form-data — let the browser set the
// boundary. Toast is fired from the saga so we don't double-notify here.
export const bulkUploadVendorsReq = (action) => {
    const { file, societyId } = action?.data || {};
    const form = new FormData();
    if (societyId) form.append('society_id', societyId);
    if (file) form.append('file', file);
    return axiosInstance.post(apiEndpoints.SOCIETY_BULK_UPLOAD_VENDORS_API, form)
        .then(response => response)
        .catch((errors) => errors);
};

export const bulkUploadVendorBillsReq = (action) => {
    const { file, societyId } = action?.data || {};
    const form = new FormData();
    if (societyId) form.append('society_id', societyId);
    if (file) form.append('file', file);
    return axiosInstance.post(apiEndpoints.SOCIETY_BULK_UPLOAD_VENDOR_BILLS_API, form)
        .then(response => response)
        .catch((errors) => errors);
};

export const bulkUploadVendorPaymentsReq = (action) => {
    const { file, societyId } = action?.data || {};
    const form = new FormData();
    if (societyId) form.append('society_id', societyId);
    if (file) form.append('file', file);
    return axiosInstance.post(apiEndpoints.SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_API, form)
        .then(response => response)
        .catch((errors) => errors);
};
